import React from 'react';
import '../style/SectionTitle.scss';
function SectionTitle({title}) {
  return (
      <div id={'SectionTitle'}>
        {title}
      </div>
  );
}

export default SectionTitle;